/**
 * Version of this frontend build. The production deploy sets VITE_APP_VERSION
 * (semantic version from scripts/release/next-version.cjs); vite.config.ts
 * injects it as __APP_VERSION__. Every other build (local, staging, tests)
 * reports "dev".
 */
const SEMVER = /^\d{1,9}\.\d{1,9}\.\d{1,9}$/;

export function resolveAppVersion(raw: unknown): string {
  const value = typeof raw === 'string' ? raw.trim().replace(/^v/, '') : '';
  return SEMVER.test(value) ? value : 'dev';
}

export const APP_VERSION: string = resolveAppVersion(
  typeof __APP_VERSION__ === 'undefined' ? undefined : __APP_VERSION__,
);
